import React from "react";
import ModalBaseView from "../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import {
    type MultipleChoiceType,
    MultipleChoice,
} from "../../../../../common-deprecated/components/modals/aem/ModalActionViews";
import { type CompareV2DispatchType, useCompareV2Selector } from "../../../redux/store";
import { compareAddCar } from "../../../../../common-deprecated/features/compare/redux/actions/NewCarCompareExternalDataActions";
import useMaxNumberToCompare from "../../../../../shared-logic/features/compare/hooks/useMaxNumberToCompare";
import { getNameFromModelGradeBodyTypeIdsAndAvailabelCars } from "../../../utils/formatters/nameFormatters";
import { CompareV2Label, useCompareV2Label } from "../../../utils/labels";
import type { ReplaceCarType } from "../../../../../shared-logic/features/compare/utils/modalConstants";
import * as Modal from "../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import * as Text from "../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import * as Type from "../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import type { ModalViewType } from "../../../../../common-deprecated/types/CommonTypes";
import { useDispatch } from "../../../../../shared-logic/redux/store";

const ToyotaReplaceCarModal = (props: ModalViewType<ReplaceCarType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { newCarToAdd } = modalSettings;

    // TODO: find a better way to handle reducers not being defined in newCars components
    // optionally chaining here because these modals are used for both used and new cars, but usedCarReducer is not initialized in eg. Build & Grade explorer
    const newCars = useCompareV2Selector((state) => state.newCarCompare?.grades || []);
    const allNewCars = useCompareV2Selector((state) => state.newCarCompare?.available || []);

    const [loadingLabel, compareModalCancelButton] = useCompareV2Label([
        "compareBodyLoading",
        "compareModalCancelButton",
    ]);

    const dispatch = useDispatch<CompareV2DispatchType>();
    const maxNumberToCompare = useMaxNumberToCompare();

    // We are injecting this label as HTML because there are 2 value fields in this single label
    let carToAddHTML = "";
    let options: MultipleChoiceType["list"] = [];
    if (newCarToAdd) {
        carToAddHTML = `<strong>${getNameFromModelGradeBodyTypeIdsAndAvailabelCars(newCarToAdd, allNewCars)}</strong>`;
        options = newCars.map((car, index) => ({
            id: `${car.id}-${index}`,
            label: car.modelName
                ? [car.modelName, car.gradeName, car.bodyTypeName].filter(Boolean).join(" ")
                : loadingLabel,
            handler: (replaceIndex: number) => {
                dispatch(compareAddCar(newCarToAdd, null, replaceIndex));
                close();
            },
        }));
    }

    const label = useCompareV2Label("compareModalReplaceCar", {
        maxNumberToCompare: `<strong>${maxNumberToCompare}</strong>`,
        newCar: carToAddHTML,
    });

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="sm">
            <Modal.Header buttonAlignment="left">
                <Modal.Button type="button" onClick={close} lightBg hasText>
                    <IconWrapper>
                        <Icon variant="arrowLeft" />
                    </IconWrapper>
                    <Text.Button>
                        <CompareV2Label label="compareSelectBack" />
                    </Text.Button>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Type.Text headingType="base" dangerouslySetInnerHTML={{ __html: label }} />
            </Modal.Body>
            <MultipleChoice list={options} onCancel={close} cancelLabel={compareModalCancelButton} />
        </ModalBaseView>
    );
};

export default ToyotaReplaceCarModal;
